const STORAGE_KEY = "pipedrive_opened_leads";

export function getOpenedLeadIds() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed.map(String) : [];
  } catch {
    return [];
  }
}

export function isLeadOpened(id) {
  if (id == null) return false;
  return getOpenedLeadIds().includes(String(id));
}

export function markLeadOpened(id) {
  if (id == null) return;
  const key = String(id);
  const ids = getOpenedLeadIds();
  if (ids.includes(key)) return;
  localStorage.setItem(STORAGE_KEY, JSON.stringify([...ids, key]));
}

export function daysSince(dateLike) {
  if (!dateLike) return null;
  const d = new Date(dateLike);
  if (Number.isNaN(d.getTime())) return null;
  const ms = Date.now() - d.getTime();
  return Math.max(0, Math.floor(ms / (1000 * 60 * 60 * 24)));
}
